module.exports = __webpack_public_path__ + "c2cd5b73b9947fa291b8c23aab02c0b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-parvulo-white.png
// module id = 111
// module chunks = 0